export const CONFIDENCE_BARS = [
    'shortBar',
    'middleBar',
    'tallBar'
];
const FILLED_BARS_BY_BAND = {
    high: 3,
    medium: 2,
    low: 1
};
export const filledConfidenceBars = (band)=>FILLED_BARS_BY_BAND[band];
